import { useCallback } from 'react';

import useUiTranslation from 'src/hooks/useUiTranslation';

const useGetGalenErrorMsg = () => {
  const { tCommon } = useUiTranslation();
  const getErrorMessage = useCallback(
    (key: string) => {
      return tCommon(`message.error.${key}`, { defaultValue: 'Unknown error' });
    },
    [tCommon],
  );

  return { getErrorMessage };
};

export default useGetGalenErrorMsg;
